import type { appConfigType } from '../platformTypes';

export const config: appConfigType = {
	title: 'BedrijfsHelden',
	permissions: { allowSkins: false, allowVariants: false, allowGps: false, allowAr: false, allowBingo: false },
	gameTypes: ['standard'],
	skin: {
		name: 'Default Skin',

		skinRounding: 'medium',

		skinLogo: undefined,
		skinFont: 'Jost',
		skinTextFont: 'Jost',
		skinBg: '#f5f5f5',
		skinBgImage: undefined,
		skinBgMode: 'cover',
		skinText: '#091d3e',

		skinBgButton: '#e0006f',
		skinBorderButton: '#e0006f',
		skinTextButton: '#ffffff',

		skinBgInput: '#ffffff',
		skinBorderInput: '#091d3e',
		skinTextInput: '#000000',

		skinBgBadge: '#e0006f',
		skinTextBadge: '#ffffff',
	},
};
